import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Layout/Header";
import Footer from "../../components/Layout/Footer";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import bannerbg from "../../assets/images/backgrounds/page-header-bg.jpg";
import { getMyFavorites, toggleFavorite } from "../../services/favoriteService";
import imgPlaceholder from "../../assets/images/resources/img-placeholder.svg";
import { EVENT_IMAGE_POOL, pickPoolImage } from "../../utils/imagePools";

const formatDate = (iso) => {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

const MyFavorites = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    getMyFavorites()
      .then((data) => setEvents(data.data || []))
      .catch(() => setError("Favorites লোড করা যায়নি।"))
      .finally(() => setLoading(false));
  }, []);

  const handleRemove = async (event) => {
    await toggleFavorite(event.id);
    setEvents((prev) => prev.filter((e) => e.id !== event.id));
  };

  return (
    <React.Fragment>
      <Header parentMenu="my-favorites" activeMenu="/my-favorites" />
      <SiteBreadcrumb pageTitle="My Favorites" pageName="My Favorites" breadcrumbsImg={bannerbg} />

      <section className="blog-one" style={{ padding: "80px 0" }}>
        <div className="container">
          {loading && <p>লোড হচ্ছে...</p>}
          {error && <p style={{ color: "#e6394f" }}>{error}</p>}
          {!loading && !error && events.length === 0 && <p>এখনো কোনো Event favorite করা হয়নি।</p>}

          <div className="row">
            {events.map((event) => (
              <div key={event.id} className="col-xl-4 col-lg-4 col-md-6">
                <div className="blog-one__single">
                  <div className="blog-one__img">
                    <img
                      src={event.image || pickPoolImage(EVENT_IMAGE_POOL, event.id ?? event.slug ?? event.title) || imgPlaceholder}
                      alt={event.title}
                      onError={(e) => { e.target.onerror = null; e.target.src = imgPlaceholder; }}
                    />
                  </div>
                  <div className="blog-one__content">
                    <ul className="blog-one__meta list-unstyled">
                      <li>
                        <span className="icon-calendar"></span> {formatDate(event.start_date)}
                      </li>
                    </ul>
                    <h3 className="blog-one__title">
                      <Link to={`/events/${event.slug}`}>{event.title}</Link>
                    </h3>
                    <div className="blog-one__btn-box-two" style={{ display: "flex", gap: 10 }}>
                      <Link to={`/events/${event.slug}`} className="blog-one__btn-2 thm-btn">
                        View Details <span className="icon-arrow-right"></span>
                      </Link>
                      <button
                        onClick={() => handleRemove(event)}
                        className="thm-btn"
                        style={{ background: "#eee", color: "#333" }}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </React.Fragment>
  );
};

export default MyFavorites;
